const EMPTY_FIELD_PLACEHOLDER = '<No Data>';

const validateFieldForPlaceholder = (data) => {
  if (data === null || data === undefined) return EMPTY_FIELD_PLACEHOLDER;
  else if (typeof data === 'number') return data;
  else if (Array.isArray(data) && data.length !== 0) return data;
  else if (typeof data === 'string' || typeof data === 'object') {
    if (data.length) {
      let parsedData;
      try {
        parsedData = JSON.parse(data);
        if (
          typeof {} === typeof parsedData &&
          Object.keys(parsedData).length === 0
        )
          return EMPTY_FIELD_PLACEHOLDER;
        return parsedData;
      } catch (error) {
        // Parsing as JSON failed, so `data` is a simple string
        // You can handle the error or perform any necessary fallback logic here
        return data;
      }
    } else if (data === '' || Object.keys(data).length === 0) {
      return EMPTY_FIELD_PLACEHOLDER;
    } else if (data === 'true' || data === 'false')
      return data === 'true' ? 'Yes' : 'No';
    return data;
  } else if (typeof data === 'boolean') {
    return data === true ? 'Yes' : 'No';
  }

  return data;
};

export default validateFieldForPlaceholder;
